import styles from './Login.module.css';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import axios from 'config/axios';
import TokenService from 'config/token.service';
import { useDispatch } from 'react-redux';
import { updateFlag } from 'store/UserSession';
import { fetchUser } from 'store/UserSession/features';

import { Alert, AlertTitle, CircularProgress, IconButton } from '@mui/material';
import ForgotPasswordModal from 'components/shared/modal/ForgotPasswordModal';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { LANGUAGES } from 'utils/Constants';
import i18n from 'i18next';

function Login() {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [language, setLanguage] = useState(i18n.language);

  const [forgotPassword, setForgotPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChangeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
    setLanguage(languageCode);
    localStorage.setItem('language', languageCode);
  };

  const loginIllustration =
    language?.startsWith('en')
      ? '/Images/illu-login-en.png'
      : '/Images/illu-login.png';

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    axios
      .post('/user/auth/login', { mail: email, password: password })
      .then((response) => {
        TokenService.setUser(response.data);
        dispatch(fetchUser(response.data));
        dispatch(updateFlag(true));
      })
      .catch((e) => {
        switch (e.response.status) {
          case 400:
            setErrorMessage(t('Veuillez saisir des champs valides'));
            break;
          case 404:
            setErrorMessage(`${t("L'émail")} ${email} ${t("n'existe pas")}`);

            break;
          case 401:
            setErrorMessage(t('Mot de passe incorrect'));
            break;
            case 406:
                setErrorMessage(t('Votre compte n’a pas encore été activé. Veuillez le valider en cliquant sur le lien reçu par e-mail.'));
                break;
          default:
            setErrorMessage(t("Une erreur s'est produite lors de l'enregistrement. Notre équipe a été notifiée."));
            break;
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className={styles.loginPageContainer}>
      <div className={styles.LoginformContainer}>
        <div>
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
            <img
              src="/Images/new1-logo.png"
              alt="Logo Typix"
              className={styles.formLogo}
            />
            
           
            <div className="btn-menu-icon" style={{ position: 'absolute', right: '0', top: '50%', transform: 'translateY(-50%)' }}>
              <div
                className="box-icon-menu dropdown-toggle d-flex flex-row align-items-center"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>
                  <div className="flag-img-container-country">
                    <img
                      src={
                        LANGUAGES.find(({ isoCode }) => isoCode === language)
                          ?.img
                      }
                      alt="langage icon"
                    />
                  </div>
                </span>
              </div>
              <ul
                className="dropdown-menu menu-list-nav menu-list-lng"
                aria-labelledby="dropdownMenu2"
              >
                {LANGUAGES.filter(({ isoCode }) => isoCode === 'fr' || isoCode === 'en').map(({ isoCode, img }, index) => (
                  <li
                    key={index}
                    onClick={() => handleChangeLanguage(isoCode)}
                  >
                    <button
                      className="dropdown-item d-flex justify-content-center"
                      type="button"
                    >
                      <div className="flag-img-container">
                        <img src={img} alt="language icon" />
                      </div>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <h1 className={styles.formTitle}>{t('Bienvenue !')}</h1>
        </div>

        <p className={styles.formSubTitle}>
          {t('Accédez à votre compte pour gérer vos contenus.')}
        </p>

        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <div className={styles.inputContainer}>
            <label htmlFor="email">{t('Email')}</label>

            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder={t('Veuillez saisir votre adresse mail')}
            />
          </div>

          <div className={styles.inputContainer}>
            <label htmlFor="password">{t('Mot de passe')}</label>

            <div className={styles.passwordWrapper}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder={t('Entrez votre mot de passe')}
              ></input>

              <IconButton
                aria-label="toggle password visibility"
                onClick={handleTogglePasswordVisibility}
                className={styles.togglePassword}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </div>
          </div>

          {errorMessage && (
            <Alert className={styles.alertError} severity="error">
              <AlertTitle>{t('Erreur')}</AlertTitle>
              {errorMessage}
            </Alert>
          )}
 <a
            onClick={(e) => {
              e.preventDefault();
              setForgotPassword(true);
            }}
            href="#"
            className={styles.forgotPasswordLink}
            style={{
              display: 'block',
              color: '#1A1A1A',
            }}
          >
            {t('mot de passe oublié')} ?
          </a>
          <button
            disabled={loading}
            className={styles.loginButton}
            type="submit"
          >
            {loading ? (
              <CircularProgress size={24} style={{ color: 'white' }} />
            ) : (
              t('Se connecter')
            )}
          </button>

         
        </form>

        <div className={styles.separator}>{t('Vous n\'avez pas de compte ?')}</div>

        <span>
          {t("Passez à l'action !")}{' '}
          <a href="/signup" className={styles.signupLink}>
            {t('Inscrivez-vous gratuitement pour commencer.')}
          </a>
        </span>
      </div>

      <div className={styles.gradientBox}>
        <h1 className={styles.loginTitle}>{t('Accélérez votre stratégie')}</h1><br />
         <h1 style={{marginLeft: '500px', fontWeight: '450', color:'#1A1A1A'}}>{t(' de contenu.')}</h1>
        <p className={styles.loginSubTitle}>{t('IA générative, optimisation SEO avancée et validation  ')}</p> <br />
        <p style={{marginLeft: '450px',color: '#00000066', fontSize: '15px'}}>{t('humaine intégrées dans un seul workflow.')}</p>
        <img src={loginIllustration} alt="Login" className={styles.loginImage} />
      </div>

      <ForgotPasswordModal
        open={forgotPassword}
        handleClose={() => setForgotPassword(false)}
      />
    </div>
  );
}

export default Login;